import { useQuery } from "@apollo/client";
import { Select } from "@mantine/core";
import { useForm } from "@mantine/form";
import { GET_ALL_USERS } from "apollo/queries";
import { useEffect, useState } from "react";

export default function SupplierFilter({ onCardClick, supplier }) {
  const form = useForm({
    initialValues: {
      supplier: null,
    },
  });
  const [suppliers, setSuppliers] = useState([]);

  const { loading: supplierLoading, refetch } = useQuery(GET_ALL_USERS, {
    variables: {
      first: parseInt(100000),
      page: 1,
      search: "",
      role: "supplier",
    },

    onCompleted(data) {
      const arr = data.users.data.map((item) => ({
        label: item.name,
        value: item.id,
      }));

      setSuppliers(arr);
    },
  });
  useEffect(() => {
    refetch();
  }, []);
  const handleSupplierSelect = (value) => {
    form.setFieldValue("supplier", value);
    if (onCardClick) {
      onCardClick(value);
    }
  };

  return (
    <Select
      placeholder="Filter By Supplier"
      data={suppliers}
      value={form.values.supplier || supplier}
      onChange={(value) => {
        handleSupplierSelect(value);
      }}
      onClear={() => handleSupplierSelect(null)}
      clearable
      searchable
      withinPortal
    />
  );
}
